import Breadcrumb from "./widget/Breadcrumb";
import Facility from "./widget/facility";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";



const Facilities = () => {
  return (
    <>
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Facilities"} />

        {/* EventsAllOne */}
        <Facility />

        {/* FooterOne */}
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Facilities;
